import React from 'react';

import { getStaffRequest } from '@vyce/core/src/api/companies';
import { TeamsReportsRoute } from '@vyce/core/src/views/teamsReports';

import { useTypedSelector } from 'src/hooks';

export const TeamsReports: React.FC = () => {
  const { uuid } = useTypedSelector(state => state.user);
  const { selectedCompany } = useTypedSelector(state => state.helper);

  return (
    <TeamsReportsRoute
      clientApp="work"
      currentUserId={uuid}
      companyName={selectedCompany?.name}
      getStaff={getStaffRequest}
    />
  );
};
